// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1Qg5E","label":"Section_label__2laS9","contentWrap":"Section_contentWrap__3QtK4","footer":"Section_footer__CpHzO","footerInner":"Section_footerInner__3KjT3"};